import { render, staticRenderFns } from "./VacancyDetails.vue?vue&type=template&id=329bdf8f&"
import script from "./VacancyDetails.vue?vue&type=script&lang=js&"
export * from "./VacancyDetails.vue?vue&type=script&lang=js&"
import style0 from "./VacancyDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports